import { Controller } from "@hotwired/stimulus"

// Per-resource-group enable-all / disable-all toggles for the role permission
// grid (RBAC #3090). Scoped per resource group: one controller instance per
// group container, so enableAll/disableAll only affect that group's checkboxes
// (its own permission-group-toggle#checkbox targets), never other groups.
//
// Usage in view:
//   <div data-controller="permission-group-toggle">
//     <button type="button" data-action="permission-group-toggle#enableAll">Enable all</button>
//     <button type="button" data-action="permission-group-toggle#disableAll">Disable all</button>
//     <input type="checkbox" data-permission-group-toggle-target="checkbox">
//   </div>
//
export default class extends Controller {
  static targets = ["checkbox"]

  enableAll(event) {
    if (event) event.preventDefault()
    this.setAll(true)
  }

  disableAll(event) {
    if (event) event.preventDefault()
    this.setAll(false)
  }

  setAll(checked) {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
  }
}
